import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';
import { ROLEPLAY_CACHE_KEYS } from 'features/roleplay/Roleplay.queries';
import { useLocation, useHistory } from 'react-router-dom';

const mutationFn = async ({ roleplay = {} }) => {
  const url = `v3/roleplays/self-assign/`;
  const data = await API.post(url, { ...roleplay });
  return data;
};

const useSelfAssignRealPlayMutation = () => {
  let location = useLocation();
  let history = useHistory();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (response) => {
      toastFlashMessage(response?.message, 'success');
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.ASSIGNED_TO_ME]);
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.PROGRESS_GRAPH]);
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.TO_REVIEW]);
      history.push({
        pathname: `/realplay/${response?.uuid}`,
        state: {
          prevPath: `${location.pathname}${location.search ? location.search : ''}`,
        },
      });
    },
  });
};

export default useSelfAssignRealPlayMutation;
